import React from "react";
import {toRgba} from "../imageCarouselSlideButton/ImageCarouselSlideButton";
import styles from "./ImageCounter.module.css";

interface ImageCounterProps {
    brandColour: string
    currentIndex: number
    images: string[];
}

export const ImageCounter: React.FC<ImageCounterProps> = ({
                                                              brandColour,
                                                              currentIndex,
                                                              images,
                                                          }) => {
    const bgColor = toRgba(brandColour, 0.65);

    return (
        <div
            className={styles.counter}
            style={{background: bgColor}}
        >
            <img
                src="/camera.svg"
                alt="Camera"
                className={styles.icon}
            />
            <span className={styles.text}>
                {currentIndex + 1}/{images.length}
            </span>
        </div>
    );
};
